import React from "react"
import PropTypes from "prop-types"

import { TagBox } from "./tag.styled"
import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"

/**
 * Renders a tag component with customizable text and styling.
 *
 * The `Tag` component displays a piece of text within a styled box, allowing for custom
 * class names to be applied for further styling. The text and its styling can be customized
 * through the `data` prop, which includes the text to be displayed (`line`), a class for the
 * `TagBox` (`classes`), and a class for the text itself (`fontclasses`). The `fontclasses` prop
 * defaults to "text-nova-base-black" if not provided.
 *
 * @param {Object} props - Component props.
 * @param {Object} props.data - Data for the tag component.
 * @param {string} props.data.line - The text content for the tag.
 * @param {string} [props.data.classes] - Optional CSS class(es) for the `TagBox`.
 * @param {string} [props.data.fontclasses="text-nova-base-black"] - Optional CSS class(es) for the text styling, defaults to "text-nova-base-black".
 * @returns {JSX.Element} The rendered tag component.
 */
const Tag = ({ data }) => {
  const {
    line = ``,
    classes = `bg-nova-base-solid-20`,
    fontclasses = "text-nova-base-black",
  } = data
  if (!line) {
    return null
  }
  return (
    <TagBox className={classes}>
      <TextElementNova
        text={line}
        element="span"
        className={fontclasses + " Caption-10-Dia-Uppercase"}
      />
    </TagBox>
  )
}

Tag.propTypes = {
  data: PropTypes.shape({
    line: PropTypes.string.isRequired,
    classes: PropTypes.string,
    fontclasses: PropTypes.string,
  }).isRequired,
}
export default Tag
